export default __webpack_public_path__ + "static/shield-21e00c260bb68843a14c7c4415276992.png";